import React from 'react';
import { notify } from 'react-notify-toast';

export const notifyMessages = {
  requestUpdatedSuccessfully: {
    text: 'Request has been successfully updated.',
    type: 'success'
  },
  pocEmailAlreadyExists: {
    text: 'Email address for POC already exists.',
    type: 'error'
  },
  modelnameAlreadyExists: {
    text: 'Model name/number already exists.',
    type: 'error'
  },
  cantSignAgreement: {
    text: 'An error occurred when signing the License Agreement.',
    type: 'error'
  },
  cantSubmitRequest: {
    text: 'An error occurred when submitting the request.',
    type: 'error'
  },
  cantUpdateRequest: {
    text: 'An error occurred when updating the request.',
    type: 'error'
  },
  cantWithdrawRequest: {
    text: 'An error occurred when withdrawing the request.',
    type: 'error'
  },
  cantUnwithdrawRequest: {
    text: 'An error occurred when unwithdrawing the request.',
    type: 'error'
  },
  cantSendTestResult: {
    text: 'An error occurred when sending Test Result.',
    type: 'error'
  },
  cantDeleteUploadedFile: {
    text: 'An error occurred trying to delete selected file.',
    type: 'error'
  },
  documentDeletedSuccessfully: {
    text: 'Document has been successfully deleted.',
    type: 'success'
  },
  documentApprovedSuccessfully: {
    text: 'Document has been successfully approved.',
    type: 'success'
  },
  documentRejectedSuccessfully: {
    text: 'Document has been successfully rejected.',
    type: 'success'
  },
  requestApprovedSuccessfully: {
    text: 'Request has been successfully approved.',
    type: 'success'
  },
  requestWithdrawnSuccessfully: {
    text: 'Request has been successfully withdrawn.',
    type: 'success'
  },
  requestUnwithdrawnSuccessfully: {
    text: 'Request has been successfully unwithdrawn.',
    type: 'success'
  },
  cantDownloadFile: {
    text: 'This file can not be downloaded.',
    type: 'error'
  },
  cantDeleteFile: {
    text: 'This file can not be deleted.',
    type: 'error'
  },
  fccidAssigned: {
    text: 'FCCID has been successfully assigned.',
    type: 'success'
  },
  cantSignVendorAgreement: {
    text: 'An error occurred when signing the Vendor Agreement.',
    type: 'error'
  },
  vendorAgreementSigned: {
    text: 'The Vendor Agreement has been successfully signed.',
    type: 'success'
  },
  authError: {
    text: 'You are not authorized to access this web site. Please, log in.',
    type: 'error'
  },
  errorFetchRequestAction: {
    text: 'An error occurred during fetching the request data from server.',
    type: 'error'
  },
  cantCreateBillingEntry: {
    text: 'An error occurred during creating new billing entry.',
    type: 'error'
  },
  errorAsyncAction: {
    text: 'An error occurred during fetching data from server.',
    type: 'error'
  },
  paymentUpdatedSuccessfully: {
    text: 'Payment Information has been successfully updated.',
    type: 'success'
  },
  errorLabRequestAction: {
    text: 'An error occurred during changing request status.',
    type: 'error'
  }
};

export const send = (message, type) => {
  notify.show(<b>{message}</b>, type);
};



// WEBPACK FOOTER //
// ./src/helpers/NotifyHelper.js